import { getErrorStatus, isApiError } from '@/shared/types/api-error';
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes (formerly cacheTime)
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: (failureCount, error: unknown) => {
        // Không retry cho 401, 403, 404
        const status = getErrorStatus(error);
        if (status && [403, 404].includes(status)) {
          return false;
        }
        // Retry tối đa 3 lần cho các lỗi khác
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => {
        // Exponential backoff: 1s, 2s, 4s
        return Math.min(1000 * 2 ** attemptIndex, 10000);
      }
    },
    mutations: {
      retry: (failureCount, error: unknown) => {
        // Chỉ retry cho network errors và 5xx
        const status = getErrorStatus(error);
        if ((status && status >= 500) || (isApiError(error) && error.code === 'NETWORK_ERROR')) {
          return failureCount < 3;
        }
        return false;
      },
      retryDelay: 1000
    }
  }
});
